<!-- 由 woniu6162 创建于 2019-07-01 星期一 -->
<template>
  <svg aria-hidden="true">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  name: 'vSvg',

  mixins: [],

  components: {},

  props: {
    icon: {
      type: String,
      required: true
    }
  },

  data() {
    return {}
  },

  computed: {
    iconName() {
      return `#${this.icon}`
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style lang="scss">
.svg_icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
